define(['app/modules/forms', 'app/modules/utilities', 'app/modules/filteringList', 'vendor/jquery.stellar.min.js'], function(Forms, Util, FilteringList) {
  var Partners = function () {};

  Partners.prototype.actionIndex = function() {
    new FilteringList({
      onSuccess: function(result){
        if(result.jobs_html){
          $('.js-filtering-list').html(result.jobs_html);
        }
      }
    });

    $('.container').stellar({
      horizontalScrolling: false,
      scrollProperty: 'transform'
    });
  };

  return Partners;
});
